import { Action, handleActions } from 'redux-actions'
import {
  setLoginInProgress,
  checkLoginMethod,
  checkLoginMethodSuccess,
  checkLoginMethodFail,
  resetLoginStep,
} from './LoginActions'
import { LoginMethod } from '../../../services/api.types'

/**
 * Login state manages both the traditional password login
 * and the new email-first SSO flow.
 *
 * step: 'email' = user enters email first
 * step: 'credentials' = user sees password/SSO options based on loginMethod
 */
class State {
  loginInProgress: boolean = false
  // Email-first flow state
  step: 'email' | 'credentials' = 'email'
  loginMethod: LoginMethod | null = null
  ssoCompanyId: string | null = null
  ssoCompanyName: string | null = null
  ssoConfigId: string | null = null
  isCheckingLoginMethod: boolean = false
}

export const login = handleActions<State, any>(
  {
    [String(setLoginInProgress)]: (state: State, action: Action<boolean>): State => ({
      ...state,
      loginInProgress: action.payload,
    }),

    // When checkLoginMethod is dispatched, show loading state
    [String(checkLoginMethod)]: (state: State): State => ({
      ...state,
      isCheckingLoginMethod: true,
    }),

    // On successful checkLoginMethod response, move to credentials step
    [String(checkLoginMethodSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      isCheckingLoginMethod: false,
      step: 'credentials',
      loginMethod: action.payload.loginMethod,
      ssoCompanyId: action.payload.companyId || null,
      ssoCompanyName: action.payload.companyName || null,
      ssoConfigId: action.payload.ssoConfigId || null,
    }),

    // On checkLoginMethod failure, stay on email step
    [String(checkLoginMethodFail)]: (state: State): State => ({
      ...state,
      isCheckingLoginMethod: false,
    }),

    // Reset back to email step (e.g. user clicks "Use different email")
    [String(resetLoginStep)]: (state: State): State => ({
      ...state,
      step: 'email',
      loginMethod: null,
      ssoCompanyId: null,
      ssoCompanyName: null,
      ssoConfigId: null,
      isCheckingLoginMethod: false,
    }),
  },
  new State(),
)

export { State as LoginState }
